import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { api } from './api';

// Custom Tooltip Component
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
        <p>{`Name: ${payload[0].payload.name}`}</p>
        <p>{`Profit: ${payload[0].value}`}</p>
        <p>{`Quantity: ${payload[1].value}`}</p>
      </div>
    );
  }
  return null;
};

const HighProfitVsVolumeChart = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    api.get('/api/dash/high-profit-vs-volume')
      .then(res => {
        const formatted = res.data.map(item => ({
          tooltipItemId: item.itemid, // X-Axis will use this
          name: item.product_name, // Tooltip will display this
          Profit: parseFloat(item.total_profit),
          Quantity: parseFloat(item.total_quantity),
        }));
        setData(formatted);
      })
      .catch(err => console.error('Error fetching chart data:', err));
  }, []);

  return (
    <div className="card mt-4">
      <div className="card-header bg-dark text-white">
        High-Profit vs High-Volume Products
      </div>
      <div className="card-body" style={{ height: 400 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="tooltipItemId" interval={0} angle={-45} textAnchor="end" height={80} />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Bar dataKey="Profit" fill="#8884d8" />
            <Bar dataKey="Quantity" fill="#82ca9d" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default HighProfitVsVolumeChart;
